export const supportedLocales = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  ko: '한국어',
  ja: '日本語',
  'zh-CN': '中文',
};

export const LAST_LANGUAGE_LOCAL_STORAGE_KEY = 'bridge/last-language';
